import { type StaticEncode, Type } from '@sinclair/typebox';
import type { PodcastGenre } from '../models/podcast-genres.js';
import { obfuscateEmailAddress } from '../utils/string.util.js';
import { ChannelDTOSchema } from './channel.dto.js';
import { MongooseRefSchema } from './common.dto.js';
import { TierDTOSchema } from './tier.dto.js';

export const PODCAST_AUTHOR_MAX_LENGTH = 200;

export const PodcastDTOSchema = Type.Composite([
  ChannelDTOSchema,
  Type.Object({
    author: Type.Transform(Type.String())
      .Decode(v => v)
      .Encode(v => v.slice(0, PODCAST_AUTHOR_MAX_LENGTH)),
    categories: Type.Optional(Type.Array(Type.Unsafe<PodcastGenre>(Type.String()))),
    config: Type.Object({
      defaultItemsVisibility: Type.Union([
        Type.Literal('public'),
        Type.Literal('hidden'),
        MongooseRefSchema(TierDTOSchema),
      ]),
      isPublished: Type.Boolean(),
      usePodcastImageAsEpisodeImage: Type.Boolean(),
      hostedByFuuze: Type.Optional(Type.Boolean()),
    }),
    explicit: Type.Boolean(),
    feedUrl: Type.String(),
    itunesTrackId: Type.Optional(Type.Number()),
    ownerEmail: Type.Optional(
      Type.Transform(Type.String())
        .Decode(v => v)
        .Encode(v => obfuscateEmailAddress(v)),
    ),
    summary: Type.Optional(Type.String()),
  }),
]);

export type PodcastDTO = StaticEncode<typeof PodcastDTOSchema>;
